<template>
    <div class="content_box">
        <div class="content order-detail">
            <div class="detail_box">
                <div class="log_box">
                    <div class="log_box_inner">
                        <div class="reply_box">
                            <div class="title_box">
                                <div class="title">
                                    <span>{{ '工单号: ' + (orderInfo.work_num || '') }}</span>
                                    <span class="order_state"
                                        :class="orderInfo.work_state == 'Running' ? 'running' : 'end'">
                                        <span v-if="orderInfo.work_state == 'Running'">(受理中)</span>
                                        <span v-if="orderInfo.work_state == 'End'">(已完结)</span>
                                    </span>
                                </div>
                                <!-- <div class="act_box">
                                <div class="button del white" @click="delOrder" v-if="roleCheck('101-102-101-106')">
                                    <span>删除工单</span>
                                </div>
                                <div class="button transfer white" @click="openDialog('restart', '重启工单')"
                                    v-if="workState == 'End' && role > 2">
                                    <span>重启工单</span>
                                </div>
                                <div v-if="workState == 'Running'">
                                    <div class="button reminders white" @click="openDialog('reminders', '催单')"
                                        v-if="role > 2">
                                        <span>催单</span>
                                    </div>
                                    <div class="button transfer white" @click="openDialog('transfer', '转交工单')"
                                        v-if="role > 1">
                                        <span>转交工单</span>
                                    </div>
                                    <div class="button end white" @click="openDialog('end', '完结工单')" v-if="role > 2">
                                        <span>完结工单</span>
                                    </div>
                                </div>
                            </div> -->
                            </div>
                            <div class="reply_area">
                                <div class="work_title" v-if="this.editTitle == false">
                                    <div class="order_text">
                                        <div class="order_title">{{ '标题：' + (orderInfo.work_title || '') }}</div>
                                        <div class="order_desc">{{ '详情描述：' + (orderInfo.work_desc || '') }}</div>
                                    </div>
                                    <el-button type="text" v-if="role > 1 && orderInfo.work_state == 'Running'"
                                        @click="editTitle = true">
                                        <img class="ico" src="../../../assets/images/ico/ic_edit.png" alt="">
                                        <!-- <i class="el-icon-edit"></i> -->
                                    </el-button>
                                </div>
                                <el-form :model="orderInfo" label-position="left" label-width="90px" ref="orderInfo"
                                    v-else>
                                    <el-form-item label="标题：" class="mb" prop="work_title">
                                        <el-input v-model="orderInfo.work_title" maxlength="50"></el-input>
                                    </el-form-item>
                                    <el-form-item label="详情描述：" class="mb" prop="work_desc">
                                        <el-input type="textarea" v-model="orderInfo.work_desc"
                                            maxlength="300"></el-input>
                                    </el-form-item>
                                    <el-form-item class="btn_align">
                                        <el-button type="text" @click="save('editTitle')">保存</el-button>
                                        <el-button type="text btn_color" @click="save('orderInfo')">取消</el-button>
                                    </el-form-item>
                                </el-form>
                                <!-- <div class="reply" v-show="workState == 'Running' && role > 0">
                                <el-input type="textarea" v-model="replyData.action_desc" rows="3" maxlength="300"
                                    show-word-limit placeholder="请输入你的跟进结果"></el-input>
                                <div class="upload_file">
                                    <div class="upload_left">
                                        <upload @fileChange="fileChange" ref="reply" :key="searchData.work_id"></upload>
                                    </div>
                                    <div class="upload_right">
                                        <div class="button search" :class="reply ? 'info_update' : 'not_act'"
                                            @click="save('reply')">
                                            <span>回复</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            </div>
                        </div>
                        <div class="log">
                            <div class="title_box">
                                <div class="title">
                                    <span>工单记录</span>
                                </div>
                            </div>
                            <div class="log_area">
                                <el-collapse v-model="logActive">
                                    <el-collapse-item v-for="item in workLog" :key="item.id + 5784783" :name="item.id">
                                        <template slot="title">
                                            <div class="collapse_title">
                                                <div class="title_left">
                                                    <span class="handle_name">{{ item.user_name }}</span> &nbsp;&nbsp;
                                                    <span class="handle_desc"
                                                        v-if="item.action == 'create_action'">新建了工单</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'modify_action'">修改了工单</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'reply_action'">回复了工单</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'forward_action'">将工单转交给</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'end_action'">完结了工单</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'restart_action'">重启了工单</span>
                                                    <span class="handle_desc"
                                                        v-if="item.action == 'link_action'">关联了工单</span>
                                                    <span class="handle_desc"
                                                        v-if="item.action == 'unlink_action'">取消关联了工单</span>
                                                    <span class="handle_desc"
                                                        v-else-if="item.action == 'reminder_action'">向</span>
                                                    &nbsp;&nbsp; <span class="handle_name"
                                                        v-if="item.action == 'forward_action' || item.action == 'reminder_action'">{{
                                                                item.forward_name
                                                                || item.handler_name
                                                        }}</span>
                                                    <span v-if="item.action == 'reminder_action'">发起了催单</span>
                                                </div>
                                                <div class="collapse_time">{{ formDate(item.action_unix ||
                                                        item.create_unix)
                                                }}</div>
                                            </div>
                                        </template>
                                        <div v-if="item.action == 'modify_action'">
                                            <p class="modify_info" v-for="desc in descForm(item.action_desc)">
                                                <span>{{ desc.key }}</span>
                                                <span>{{ ' 由“' + (desc.value_old || '-') + '”更改为“' + (desc.value_new ||
                                                        '-')
                                                        + '”'
                                                }}</span>
                                            </p>
                                        </div>
                                        <div class="create_info" v-else-if="item.action == 'create_action'">
                                            <el-form :model="descForm(item.action_desc)" label-position="left"
                                                label-width="140px">
                                                <el-form-item label="外部工单号：">
                                                    <span>{{ descForm(item.action_desc).work_idout || '' }}</span>
                                                </el-form-item>
                                                <el-form-item label="工单标题：">
                                                    <span>{{ descForm(item.action_desc).work_title || '' }}</span>
                                                </el-form-item>
                                                <el-form-item label="工单描述：">
                                                    <span>{{ descForm(item.action_desc).work_desc || '' }}</span>
                                                </el-form-item>
                                                <el-form-item label="工单优先级：">
                                                    <span>{{ priority[descForm(item.action_desc).priority] }}</span>
                                                </el-form-item>
                                                <el-form-item label="工单来源：">
                                                    <span>{{ descForm(item.action_desc).work_source }}</span>
                                                </el-form-item>
                                                <el-form-item label="受理人：">
                                                    <span>{{ descForm(item.action_desc).handler_name }}</span>
                                                </el-form-item>
                                                <el-form-item label="产品分类：">
                                                    <span>{{ descForm(item.action_desc).product_name }}</span>
                                                </el-form-item>
                                                <el-form-item label="产品型号：">
                                                    <span>{{ descForm(item.action_desc).product_type }}</span>
                                                </el-form-item>
                                                <el-form-item label="产品SN号：">
                                                    <span>{{ descForm(item.action_desc).product_sn }}</span>
                                                </el-form-item>
                                                <el-form-item label="销售渠道："
                                                    v-if="descForm(item.action_desc).hasOwnProperty('sell_channel')">
                                                    <span>{{ descForm(item.action_desc).sell_channel }}</span>
                                                </el-form-item>
                                                <el-form-item label="销售订单号："
                                                    v-if="descForm(item.action_desc).hasOwnProperty('sell_num')">
                                                    <span>{{ descForm(item.action_desc).sell_num }}</span>
                                                </el-form-item>
                                                <el-form-item label="订单日期："
                                                    v-if="descForm(item.action_desc).hasOwnProperty('sell_time')">
                                                    <span>{{ formDate(descForm(item.action_desc).sell_time,
                                                            'YYYY-MM-DD')
                                                    }}</span>
                                                </el-form-item>
                                                <el-form-item label="集尘宝编号："
                                                    v-if="item.action_desc && descForm(item.action_desc).product_name.search('扫地机器人') != -1">
                                                    <span>{{ descForm(item.action_desc).jcb_num }}</span>
                                                </el-form-item>
                                                <el-form-item label="问题分类：">
                                                    <span>{{ descForm(item.action_desc).cate }}</span>
                                                </el-form-item>
                                                <el-form-item label="问题责任方：">
                                                    <span>{{ descForm(item.action_desc).problem_source }}</span>
                                                </el-form-item>
                                                <el-form-item label="国家/地区：">
                                                    <span>{{ descForm(item.action_desc).region }}</span>
                                                </el-form-item>
                                                <el-form-item label="注册邮箱或手机号：">
                                                    <span>{{ descForm(item.action_desc).email_phone }}</span>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                        <div class="pre" v-else-if="item.action == 'link_action'">关联工单号：&nbsp;{{
                                                item.action_desc || ''
                                        }}</div>
                                        <div class="pre" v-else-if="item.action == 'unlink_action'">取消关联工单号：&nbsp;{{
                                                item.action_desc || ''
                                        }}</div>
                                        <div class="pre" v-else>{{ item.action_desc || '' }}</div>
                                        <fileShow :fileList="item.file_list_new" :type="'log'"
                                            v-if="item.file_list_new && item.file_list_new.length > 0"></fileShow>
                                    </el-collapse-item>
                                </el-collapse>
                            </div>
                        </div>
                    </div>

                    <div class="act_list">
                        <span class="button text bind_text" @click="openDialog('bind_list', '关联工单列表')">已关联&nbsp;{{
                                bindOrderList.length
                        }}&nbsp;条工单</span>
                        <div class="act_box">
                            <el-dropdown trigger="click">
                                <span class="el-dropdown-link">
                                    <div class="button white default_btn">
                                        <span>更多操作</span>
                                    </div>
                                </span>
                                <el-dropdown-menu slot="dropdown" style="padding: 0;margin:10px;width:100px;">
                                    <el-dropdown-item style="padding: 0;">
                                        <div class="button white" @click="delOrder" style="width: 100%;border: 0;"
                                            v-if="roleCheck('101-102-101-106')">
                                            <span>删除工单</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item  style="padding: 0;">
                                        <div class="button white" @click="openDialog('restart', '重启工单')" style="width: 100%;border: 0;"
                                            v-if="workState == 'End' && role > 2">
                                            <span>重启工单</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item  style="padding: 0;">
                                        <div class="button white" @click="openDialog('reminders', '催单')" style="width: 100%;border: 0;"
                                            v-if="role > 2 && workState == 'Running'">
                                            <span>催单</span>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div v-if="workState == 'Running'">
                                <div class="button white default_btn" @click="openDialog('end', '完结工单')" v-if="role > 2">
                                    <span>完结工单</span>
                                </div>
                                <div class="button transfer white" @click="openDialog('transfer', '转交工单')" v-if="role > 1">
                                    <span>转交工单</span>
                                </div>
                                <div class="button transfer white" @click="openDialog('reply', '回复工单')" v-if="role > 0">
                                    <span>回复工单</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order_content">
                    <div class="order_main">
                        <el-tabs v-model="orderContentActive">
                            <el-tab-pane label="工单信息" name="order">
                                <div class="order_info">
                                    <el-form :model="orderInfo" label-position="left" label-width="100px">
                                        <el-form-item label="外部工单号：">
                                            <el-input v-if="workState == 'Running' && role > 1"
                                                v-model="orderInfo.work_idout" maxlength="32" placeholder="请输入">
                                            </el-input>
                                            <span v-else>{{ orderInfo.work_idout }}</span>
                                            <el-button class="kd" type="text" @click="goFeedback(orderInfo.feedback_id,orderInfo.work_title,orderInfo.feedback_region)"
                                                v-if="orderInfo.feedback_id && orderInfo.feedback_region && roleCheck('103-101-101-101')">
                                                查看
                                            </el-button>
                                        </el-form-item>
                                        <el-form-item label="创建时间：">
                                            <span>{{ formDate(orderInfo.create_time) }}</span>
                                        </el-form-item>
                                        <el-form-item label="创建人：">
                                            <span>{{ orderInfo.create_user_name }}</span>
                                        </el-form-item>
                                        <el-form-item label="工单优先级：" v-if="workState == 'Running' && role > 1">
                                            <el-radio v-model="orderInfo.priority" :label="1">低</el-radio>
                                            <el-radio v-model="orderInfo.priority" :label="2">一般</el-radio>
                                            <el-radio v-model="orderInfo.priority" :label="3">紧急</el-radio>
                                        </el-form-item>
                                        <el-form-item label="工单优先级：" v-else>
                                            <span :class="'priority' + orderInfo.priority">{{
                                                    priority[orderInfo.priority
                                                    || 0]
                                            }}</span>
                                        </el-form-item>
                                        <el-form-item label="工单来源：">
                                            <el-select v-model="orderInfo.work_source" placeholder="请选择"
                                                v-if="workState == 'Running' && role > 1">
                                                <div slot="empty"></div>
                                                <el-option :label="item" :value="item" v-for="item in workSource"
                                                    :key="item + '1765'"></el-option>
                                            </el-select>
                                            <span v-else>{{ orderInfo.work_source }}</span>
                                        </el-form-item>
                                        <el-form-item label="受理人：">
                                            <span>{{ orderInfo.handler_name }}</span>
                                        </el-form-item>
                                        <el-form-item label="产品分类：">
                                            <el-select v-model="orderInfo.product_id" clearable filterable
                                                @change="productChange" placeholder="请选择"
                                                v-if="workState == 'Running' && role > 1">
                                                <el-option :label="item.product_name" :value="item.product_id"
                                                    v-for="item in product" :key="item.product_id + '433978956'">
                                                </el-option>
                                            </el-select>
                                            <span v-else>{{ orderInfo.product_name }}</span>
                                        </el-form-item>
                                        <el-form-item label="产品型号：">
                                            <el-select v-model="orderInfo.product_type" clearable filterable
                                                placeholder="请选择" v-if="workState == 'Running' && role > 1">
                                                <el-option :label="item" :value="item" v-for="item in product_types"
                                                    :key="item + '43356'"></el-option>
                                            </el-select>
                                            <span v-else>{{ orderInfo.product_type }}</span>
                                        </el-form-item>
                                        <el-form-item label="产品SN号：">
                                            <el-input v-if="workState == 'Running' && role > 1"
                                                v-model="orderInfo.product_sn" maxlength="32" placeholder="请输入">
                                            </el-input>
                                            <span v-else>{{ orderInfo.product_sn }}</span>
                                            <el-button class="kd" type="text" @click="goDevice(orderInfo.product_sn)"
                                                v-if="orderInfo.product_sn != '' && roleCheck('104-102-101-101')">
                                                查看
                                            </el-button>
                                        </el-form-item>
                                        <el-form-item label="集尘宝编号："
                                            v-if="orderInfo.product_name && orderInfo.product_name.search('扫地机器人') != -1">
                                            <el-input v-if="workState == 'Running' && role > 1"
                                                v-model="orderInfo.jcb_num" maxlength="32" placeholder="请输入"></el-input>
                                            <span v-else>{{ orderInfo.jcb_num }}</span>
                                        </el-form-item>
                                        <el-form-item class="block" label="问题分类：">

                                            <el-cascader
                                                v-if="workState == 'Running' && role > 1 && $store.state.type == 'pc'"
                                                v-model="orderInfo.cate_ids" :options="cate" :key='cascaderId'
                                                :show-all-levels="false" clearable filterable
                                                :props="{ expandTrigger: 'click', children: 'next', label: 'cate_name', value: 'cate_id' }">
                                            </el-cascader>
                                            <div class="cascader_box"
                                                v-else-if="workState == 'Running' && role > 1 && $store.state.type == 'mobile'">
                                                <van-field v-model="cascaderValue" is-link readonly placeholder="请选择"
                                                    @click="cascaderShow = true" />
                                                <van-popup v-model="cascaderShow" round position="bottom">
                                                    <van-cascader v-model="cascaderValue" title="请选择问题分类"
                                                        :options="cate"
                                                        :fieldNames="{ text: 'cate_name', children: 'next', value: 'cate_name' }"
                                                        @close="cascaderShow = false" @finish="cascaderFinish" />
                                                </van-popup>
                                            </div>
                                            <span v-else>{{ orderInfo.cate_name }}</span>
                                        </el-form-item>
                                        <el-form-item label="问题责任方：">
                                            <el-select v-model="orderInfo.problem_source" clearable filterable
                                                placeholder="请选择" v-if="workState == 'Running' && role > 1">
                                                <el-option :label="item" :value="item" v-for="item in source"
                                                    :key="item + '43356'"></el-option>
                                            </el-select>
                                            <span v-else>{{ orderInfo.problem_source }}</span>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="客户信息" name="client">
                                <el-form :model="orderInfo" label-position="left" label-width="100px">
                                    <el-form-item label="国家/地区：">
                                        <el-select v-model="orderInfo.region" filterable placeholder="请选择"
                                            v-if="workState == 'Running' && role > 1">
                                            <el-option :label="item.chinese" :value="item.chinese"
                                                v-for="(item, i) in country" :key="i + '136676'"></el-option>
                                        </el-select>
                                        <span v-else>{{ orderInfo.region }}</span>
                                    </el-form-item>
                                    <el-form-item class="label-wrap" label="客户注册邮箱/手机号：">
                                        <el-input v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.email_phone" maxlength="32" placeholder="请输入"></el-input>
                                        <span v-else>{{ orderInfo.email_phone }}</span>
                                        <el-button class="kd" type="text" @click="goUserManage(orderInfo.email_phone)"
                                            v-if="orderInfo.email_phone != '' && roleCheck('104-101-101-101')">
                                            查看
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane label="售后信息" name="returns">
                                <el-form :model="orderInfo" label-position="left" label-width="110px">
                                    <p class="receive_title">订单信息</p>
                                    <el-form-item label="销售渠道：">
                                        <el-select v-model="orderInfo.sell_channel" clearable filterable allow-create
                                            placeholder="请选择或输入" v-if="workState == 'Running' && role > 1">
                                            <el-option-group v-for="group in salesChannels" :key="group.label"
                                                :label="group.label">
                                                <el-option v-for="item in group.options" :key="item" :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-option-group>
                                        </el-select>
                                        <span v-else>{{ orderInfo.sale }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单日期：">
                                        <el-date-picker v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.sell_time" type="date" value-format="timestamp"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                        <span v-else>{{ formDate(orderInfo.sell_time, 'YYYY-MM-DD') }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单号：">
                                        <el-input v-if="workState == 'Running' && role > 1" v-model="orderInfo.sell_num"
                                            maxlength="32" placeholder="请输入">
                                        </el-input>
                                        <span v-else>{{ orderInfo.sell_num }}</span>
                                    </el-form-item>
                                    <p class="receive_title">客户收货信息</p>
                                    <el-form-item label="客户姓名：">
                                        <el-input v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.client_name" placeholder="请输入" maxlength="48"></el-input>
                                        <span v-else>{{ orderInfo.client_name }}</span>
                                    </el-form-item>
                                    <el-form-item label="联系方式：">
                                        <el-input v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.client_phone" placeholder="请输入" maxlength="48">
                                        </el-input>
                                        <span v-else>{{ orderInfo.client_phone }}</span>
                                    </el-form-item>
                                    <el-form-item label="邮编：">
                                        <el-input v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.client_email" placeholder="请输入" maxlength="48">
                                        </el-input>
                                        <span v-else>{{ orderInfo.client_email }}</span>
                                    </el-form-item>
                                    <el-form-item label="地址：">
                                        <el-input v-if="workState == 'Running' && role > 1"
                                            v-model="orderInfo.client_addr" placeholder="请输入" maxlength="50"
                                            type="textarea" autosize></el-input>
                                        <span v-else>{{ orderInfo.client_addr }}</span>
                                    </el-form-item>

                                    <p class="returns_title">售后登记</p>
                                    <div v-for="(item, index) in orderInfo.exchanged_List" class="returns_list">
                                        <el-form-item label="售后方式："
                                            v-if="workState == 'Running' && role > 1 && index == orderInfo.exchanged_List.length - 1">
                                            <el-radio v-model="item.exchanged" :label="'无需'">无需</el-radio>
                                            <el-radio v-model="item.exchanged" :label="'退货'">退货</el-radio>
                                            <el-radio v-model="item.exchanged" :label="'换货'">换货</el-radio>
                                            <el-radio v-model="item.exchanged" :label="'补发配件'">补发配件</el-radio>
                                            <el-radio v-model="item.exchanged" :label="'维修'">维修</el-radio>
                                        </el-form-item>
                                        <el-form-item label="售后方式：" v-else class="padd">
                                            <span>{{ item.exchanged || '' }}</span>
                                        </el-form-item>
                                        <el-form-item label="售后备注："
                                            v-if="workState == 'Running' && role > 1 && index == orderInfo.exchanged_List.length - 1">
                                            <el-input v-model="item.exchanged_desc" placeholder="请输入" maxlength="32">
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="售后备注：" v-else class="padd">
                                            <span>{{ item.exchanged_desc }}</span>
                                        </el-form-item>
                                        <div
                                            v-if="item.exchanged == '退货' || item.exchanged == '换货' || item.exchanged == '维修'">
                                            <div
                                                v-if="workState == 'Running' && role > 1 && index == orderInfo.exchanged_List.length - 1">
                                                <el-form-item label="客户退件单号：" class="kd_box">
                                                    <el-input class="small" v-model="item.exchanged_return_num"
                                                        placeholder="请输入" maxlength="32">
                                                    </el-input>
                                                    <el-button class="kd" type="text"
                                                        @click="goKdPage(item.exchanged_return_num)"
                                                        v-if="item.exchanged_return_num != ''">查看物流
                                                    </el-button>
                                                </el-form-item>
                                                <el-form-item label="快递/物流：">
                                                    <el-select v-model="item.exchanged_return_kd" filterable
                                                        allow-create default-first-option clearable
                                                        placeholder="请选择或输入快递/物流">
                                                        <el-option v-for="item in kdList" :key="item" :label="item"
                                                            :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="退件接收日期：">
                                                    <el-date-picker v-model="item.exchanged_return_time" type="date"
                                                        value-format="yyyy-MM-dd" :editable="true" placeholder="选择日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </div>
                                            <div v-else>
                                                <el-form-item label="客户退件单号：" class="padd kd_box">
                                                    <span>{{ item.exchanged_return_num }}</span>
                                                    <el-button class="kd" type="text"
                                                        v-if="item.exchanged_return_num != ''"
                                                        @click="goKdPage(item.exchanged_return_num)">查看物流
                                                    </el-button>
                                                </el-form-item>
                                                <el-form-item label="快递/物流：" class="padd">
                                                    <span>{{ item.exchanged_return_kd }}</span>
                                                </el-form-item>
                                                <el-form-item label="退件接收日期：">
                                                    <span>{{ item.exchanged_return_time || '' }}</span>
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <div
                                            v-if="item.exchanged == '换货' || item.exchanged == '补发配件' || item.exchanged == '维修'">
                                            <div
                                                v-if="workState == 'Running' && role > 1 && index == orderInfo.exchanged_List.length - 1">
                                                <el-form-item label="仓库寄出单号：" class="kd_box">
                                                    <el-input v-model="item.exchanged_send_num" placeholder="请输入"
                                                        maxlength="32">
                                                    </el-input>
                                                    <el-button class="kd" type="text"
                                                        v-if="item.exchanged_send_num != ''"
                                                        @click="goKdPage(item.exchanged_send_num)">查看物流
                                                    </el-button>
                                                </el-form-item>
                                                <el-form-item label="快递/物流：">
                                                    <el-select v-model="item.exchanged_send_kd" filterable allow-create
                                                        default-first-option clearable placeholder="请选择或输入快递/物流">
                                                        <el-option v-for="item in kdList" :key="item" :label="item"
                                                            :value="item">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="仓库寄出日期：">
                                                    <el-date-picker v-model="item.exchanged_send_time" type="date"
                                                        value-format="yyyy-MM-dd" :editable="true" placeholder="选择日期">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </div>
                                            <div v-else>
                                                <el-form-item label="仓库寄出单号：" class="padd kd_box">
                                                    <span>{{ item.exchanged_send_num }}</span>
                                                    <el-button class="kd" type="text"
                                                        v-if="item.exchanged_send_num != ''"
                                                        @click="goKdPage(item.exchanged_send_num)">查看物流
                                                    </el-button>
                                                </el-form-item>
                                                <el-form-item label="快递/物流：" class="padd">
                                                    <span>{{ item.exchanged_send_kd }}</span>
                                                </el-form-item>
                                                <el-form-item label="仓库寄出日期：">
                                                    <span>{{ item.exchanged_send_time || '' }}</span>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>

                                    <el-form :model="exchangedInfo" label-position="left" label-width="110px"
                                        v-if="showExchanged">
                                        <div>
                                            <el-button type="text" class="x_align"
                                                v-if="role > 1 && showExchanged == true"
                                                @click="showExchanged = false, saveState = false"><i
                                                    class="el-icon-close"></i></el-button>
                                        </div>
                                        <el-form-item label="售后方式：">
                                            <el-radio v-model="exchangedInfo.exchanged" :label="'无需'">无需</el-radio>
                                            <el-radio v-model="exchangedInfo.exchanged" :label="'退货'">退货</el-radio>
                                            <el-radio v-model="exchangedInfo.exchanged" :label="'换货'">换货</el-radio>
                                            <el-radio v-model="exchangedInfo.exchanged" :label="'补发配件'">补发配件</el-radio>
                                            <el-radio v-model="exchangedInfo.exchanged" :label="'维修'">维修</el-radio>
                                        </el-form-item>
                                        <el-form-item label="售后备注：">
                                            <el-input v-model="exchangedInfo.exchanged_desc" placeholder="请输入"
                                                maxlength="32">
                                            </el-input>
                                        </el-form-item>
                                        <div
                                            v-if="exchangedInfo.exchanged == '退货' || exchangedInfo.exchanged == '换货' || exchangedInfo.exchanged == '维修'">
                                            <el-form-item label="客户退件单号：" class="kd_box">
                                                <el-input v-model="exchangedInfo.exchanged_return_num" placeholder="请输入"
                                                    maxlength="32">
                                                </el-input>
                                                <el-button class="kd" type="text"
                                                    v-if="exchangedInfo.exchanged_return_num != ''"
                                                    @click="goKdPage(exchangedInfo.exchanged_return_num)">查看物流
                                                </el-button>
                                            </el-form-item>
                                            <el-form-item label="快递/物流：">
                                                <el-select v-model="exchangedInfo.exchanged_return_kd" filterable
                                                    allow-create default-first-option clearable
                                                    placeholder="请选择或输入快递/物流">
                                                    <el-option v-for="item in kdList" :key="item" :label="item"
                                                        :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="退件接收日期：">
                                                <el-date-picker v-model="exchangedInfo.exchanged_return_time"
                                                    type="date" value-format="yyyy-MM-dd" :editable="true"
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                        <div
                                            v-if="exchangedInfo.exchanged == '换货' || exchangedInfo.exchanged == '维修' || exchangedInfo.exchanged == '补发配件'">
                                            <el-form-item label="仓库寄出单号：" class="kd_box">
                                                <el-input v-model="exchangedInfo.exchanged_send_num" placeholder="请输入"
                                                    maxlength="32">
                                                </el-input>
                                                <el-button class="kd" type="text"
                                                    v-if="exchangedInfo.exchanged_send_num != ''"
                                                    @click="goKdPage(exchangedInfo.exchanged_send_num)">
                                                    查看物流</el-button>
                                            </el-form-item>
                                            <el-form-item label="快递/物流：">
                                                <el-select v-model="exchangedInfo.exchanged_send_kd" filterable
                                                    allow-create default-first-option clearable
                                                    placeholder="请选择或输入快递/物流">
                                                    <el-option v-for="item in kdList" :key="item" :label="item"
                                                        :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="仓库寄出日期：">
                                                <el-date-picker v-model="exchangedInfo.exchanged_send_time" type="date"
                                                    value-format="yyyy-MM-dd" :editable="true" placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                    <el-button type="text"
                                        v-if="role > 1 && showExchanged == false && workState == 'Running' && showReturnBtn"
                                        @click="showExchanged = true, saveState = true">+&nbsp;新增售后登记</el-button>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="act_box shadow" v-if="role > 1 && workState == 'Running'">
                        <div class="button" :class="saveState ? 'info_update' : 'not_act'" @click="save('modify')">
                            <span>保存</span>
                        </div>
                    </div>
                </div>
            </div>
            <Tip ref="delTip" msg="确定要删除工单吗，删除后不能再恢复哦！" @tipBack="tipBack"></Tip>
            <Tip ref="tip" msg="确定要取消关联吗？" title="取消关联">
                <template v-slot:confirm_btn>
                    <div class="button del" @click="cancelConfirm">
                        <span>确定</span>
                    </div>
                </template>
            </Tip>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="dislogAct">
                <template v-slot:content>
                    <el-form label-width="120px" :model="actData" ref="formRule" :rules="formRule">
                        <template v-if="dislog.type == 'reminders' || dislog.type == 'restart'">
                            <el-form-item label="备注：">
                                <el-input type="textarea" v-model="actData.action_desc" rows="6" maxlength="300"
                                    show-word-limit placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="dislog.type == 'transfer'">
                            <el-form-item label="工单受理人：" prop="handler_id">
                                <el-select v-model="actData.handler_id" filterable placeholder="请选择">
                                    <el-option :label="item.user_name" :value="item.user_id" v-for="item in user"
                                        :key="item.user_id" v-if="item.user_id != orderInfo.handler_id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <el-input type="textarea" v-model="actData.action_desc" rows="6" maxlength="300"
                                    show-word-limit placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="dislog.type == 'end'">
                            <el-form-item label="售后方式：" prop="exchanged">
                                <el-radio v-model="actData.exchanged" label="无需">无需</el-radio>
                                <el-radio v-model="actData.exchanged" label="退货">退货</el-radio>
                                <el-radio v-model="actData.exchanged" label="换货">换货</el-radio>
                                <el-radio v-model="actData.exchanged" label="补发配件">补发配件</el-radio>
                                <el-radio v-model="actData.exchanged" label="维修">维修</el-radio>
                            </el-form-item>
                            <el-form-item label="解决方案：" prop="action_desc">
                                <el-input type="textarea" v-model="actData.action_desc" rows="6" maxlength="300"
                                    show-word-limit placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item class="block" label="附件：">
                                <upload @fileChange="fileChange"></upload>
                            </el-form-item>
                        </template>
                        <template v-if="dislog.type == 'bind'">
                            <el-form-item label="关联工单：">
                                <el-radio v-model="bindData.type" :label="0">工单号</el-radio>
                                <el-radio v-model="bindData.type" :label="1">外部工单号</el-radio>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-if="orderType == 0" v-model="bindData.val" placeholder="请输入"></el-input>
                            </el-form-item>
                        </template>
                        <template v-if="dislog.type == 'bind_list'">
                            <div class="bind">
                                <div class="bind_btn">
                                    <div class="button btn_bg" @click="openBindDialog()" v-if="role > 0">
                                        <span class="bind_text">+&nbsp;关联工单</span>
                                    </div>
                                </div>
                                <el-table :data="bindOrderList" :fit="true" style="width:100%" highlight-current-row
                                    @row-click="goDetail" class="bind">
                                    <el-table-column prop="work_num" label="工单号" width="100"></el-table-column>
                                    <el-table-column prop="work_idout" label="外部工单号" width="120" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.work_idout || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="work_title" label="标题" width="150" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="work_state" label="工单状态">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.work_state == 'Running'" class="running">受理中</span>
                                            <span v-if="scope.row.work_state == 'End'" class="end">已完结</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="email_phone" label="客户注册邮箱/手机号" width="160"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.email_phone || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_user_name" label="创建人"></el-table-column>
                                    <el-table-column prop="handler_name" label="受理人"></el-table-column>
                                    <el-table-column prop="act" label="操作" width="150">
                                        <template slot-scope="scope">
                                            <div class="btn">
                                                <div class="button text" @click.stop="cancelBind(scope.row.work_id)">
                                                    <span>{{role > 0 ? '取消关联' : '--'}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                        <template v-if="dislog.type == 'reply'">
                            <div class="reply">
                                <el-input type="textarea" v-model="replyData.action_desc" rows="3" maxlength="300"
                                    show-word-limit placeholder="请输入你的跟进结果"></el-input>
                                <div class="upload_file">
                                    <div class="upload_left">
                                        <upload @fileChange="fileChange" ref="reply" :key="searchData.work_id"></upload>
                                    </div>
                                    <!-- <div class="upload_right">
                                        <div class="button search" :class="reply ? 'info_update' : 'not_act'"
                                            @click="save('reply')">
                                            <span>回复</span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </template>
                    </el-form>
                </template>
            </Gh-Dialog>
            <Gh-Dialog ref="bind_dislog" title="关联工单" @dialogBack="bindDialogAct">
                <template v-slot:content>
                    <el-form label-width="120px">
                        <el-form-item label="关联工单：">
                            <el-radio v-model="bindData.type" :label="0">工单号</el-radio>
                            <el-radio v-model="bindData.type" :label="1">外部工单号</el-radio>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-if="orderType == 0" v-model="bindData.val" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>

import fileShow from '../../../components/file/file-show'
import upload from '../../../components/file/upload'
export default ({
    name: 'order-detail',
    data() {
        return {
            role: 0,  // 4 管理员  3 创建者  2 受理人  1 相关人  0 普通用户
            userInfo: '',
            searchData: {
                work_id: parseInt(this.$route.params.id),
                state: 'workSum',
                page_size: 10,
                page: 1
            },
            orderInfo: {},
            orderContentActive: 'order',
            product: [],
            cate: [],
            cascaderId: 0,
            cascaderValue: '',
            cascaderShow: false,
            source: [],
            country: [],
            product_types: [],
            workSource: [],
            salesChannels: [],
            priority: ['-', '低', '一般', '紧急'],
            workState: 'Running',
            saveState: false,
            uploadUrl: process.env.BASE_API + 'work/uploadFile',
            replyData: {
                action_desc: '',
                file_list: []
            },
            reply: false,  //回复按钮开关
            dislog: {
                type: '',
                title: '',
                show: false,
            },
            user: [],
            actData: {
                exchanged: '无需',
                file_list: [],
                action_desc: ''
            },
            end: false, // 完结按钮开关
            workLog: [],
            logActive: [],
            bindListActive: 1,
            formRule: {
                handler_id: [this.requiredRule('请选择工单受理人')],
                exchanged: [this.requiredRule('请选择售后方式')],
                action_desc: [this.requiredRule('请输入解决方案')]
            },
            orderType: 0,
            bindOrderList: [],
            showbindOrder: false,
            showExchanged: false,
            exchangedInfo: {
                exchanged: '',
                exchanged_desc: '',
                exchanged_return_num: '',
                exchanged_return_kd: '',
                exchanged_send_num: '',
                exchanged_send_kd: '',
                exchanged_return_time: '',
                exchanged_send_time: '',
            },
            bindData: {
                type: 0,
                val: '',
            },
            kdList: ['FedEx', 'UPS', 'USPS', 'Canada post', 'DHL', 'ヤマト運輸', '佐川急便', 'ゆうパック', '顺丰', '京东', '中通', '韵达', '圆通', '极兔'],
            showReturnBtn: true,
            editTitle: false,
            bindOrderId: '',
        }
    },
    components: {
        fileShow,
        upload
    },
    watch: {
        'searchData.work_id': function (nId) {
            this.replyData = {
                action_desc: '',
                file_list: []
            };
            this.getOrderInfo();
            this.getBindOrder();
            this.getWorkLog();
        },
        'orderInfo': {
            handler: function (newVal, oldVal) {
                if (oldVal.work_id && newVal.work_id == oldVal.work_id) {
                    this.saveState = true;
                } else {
                    this.saveState = false;
                }
            },
            deep: true
        },
        'replyData.action_desc': function (nDesc) {
            if (!nDesc && this.replyData.file_list.length == 0) {
                this.reply = false;
            } else {
                this.reply = true;
            }
        },
        'replyData.file_list': function (nFile) {
            if (nFile.length == 0 && !this.replyData.action_desc) {
                this.reply = false;
            } else {
                this.reply = true;
            }
        },
    },
    created() {
        this.getCountry();
        this.getWorkSource();
        this.getUser();
        this.getOrderInfo();
        this.getSellChannel();
        this.getWorkLog();
        this.getBindOrder();
    },
    activated() {
        this.searchData.work_id = parseInt(this.$route.params.id);
    },
    mounted() {
    },
    methods: {
        getOrderInfo() {
            this.api.getWorkList(this.searchData).then(data => {
                if (data.data.total == 0) {
                    this.$message.warning('工单不存在！');
                    this.$router.push({ name: 'order-manage' })
                    return;
                }
                this.orderInfo = data.data.workList[0];
                this.orderInfo.product_id = this.orderInfo.product_id ? this.orderInfo.product_id : '';
                this.orderInfo.sell_time = this.orderInfo.sell_time ? this.orderInfo.sell_time * 1000 : '';
                this.workState = this.orderInfo.work_state;
                this.cascaderValue = this.orderInfo.cate_name.split('/')[this.orderInfo.cate_name.split('/').length - 1];
                if (this.orderInfo.work_state == 'Running') {
                    this.getProductCate();
                }
                if (this.orderInfo.unread_flag) {
                    this.rmUnread();
                }
                var arr = this.orderInfo.exchanged_List || [];
                if (arr.length > 0 && (arr[arr.length - 1].exchanged == '' || arr[arr.length - 1].exchanged == '无需')) {
                    this.showReturnBtn = false;
                } else {
                    this.showReturnBtn = true;
                }
                this.setRole();
            })
        },
        rmUnread() {
            this.api.rmUnread({ work_id: this.searchData.work_id }).then(data => { })
        },
        setRole() {
            setTimeout(() => {
                if (this.$store.state.userInfo.permission) {
                    let userInfo = this.$store.state.userInfo;
                    if (userInfo.role.indexOf('系统管理员') != -1) {  //系统管理员
                        this.role = 4;
                    } else if (!this.roleCheck('101-102-101-102')) {  //没有编辑权限
                        this.role = 0;
                    } else if (this.orderInfo.create_user_id == userInfo.user_id) { //创建者
                        this.role = 3;
                    } else if (this.orderInfo.handler_id == userInfo.user_id) { //受理人
                        this.role = 2;
                    } else if (this.orderInfo.links.indexOf(userInfo.user_id) != -1) { //相关人
                        this.role = 1;
                    } else {
                        this.role = 0;
                    }
                } else {
                    this.setRole();
                }
            }, 1000)
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.country = data.data.country;
            })
        },
        productChange(p) {
            this.orderInfo.product_type = '';
            this.orderInfo.problem_source = '';
            this.orderInfo.cate_ids = [];
            this.cate = [];
            this.source = [];
            this.product_types = [];
            if (p) {
                this.getCate();
                this.getProductData();
            }
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = data.data.productCateInfos;
                if (this.orderInfo.product_id) {
                    ++this.cascaderId;
                    this.getCate();
                    this.getProductData();
                }
            })
        },
        getCate() {  //需要过滤掉next为空的属性
            this.api.getCate({ product_id: parseInt(this.orderInfo.product_id) }).then(data => {
                this.cate = this.filterCate(data.data.cateInfos);
            })
        },
        filterCate(cate) {
            for (let i = 0; i < cate.length; i++) {
                if (cate[i].next && cate[i].next.length > 0) {
                    cate[i].next = this.filterCate(cate[i].next)
                } else {
                    delete cate[i].next;
                }
            }
            return cate;
        },
        getProductData() {
            for (let i = 0; i < this.product.length; i++) {
                if (this.product[i].product_id == this.orderInfo.product_id) {
                    this.source = this.product[i].problemSource;
                    this.product_types = this.product[i].productTypes;
                    this.orderInfo.product_name = this.product[i].product_name;
                    break;
                }
            }
        },
        getWorkSource() {
            this.api.getWorkSource({}).then(data => {
                this.workSource = data.data.work_sources;
            });
        },
        getSellChannel() {
            this.api.getSellChannel({}).then(data => {
                this.salesChannels = data.data.sellObj;
            })
        },
        cascaderFinish({ selectedOptions }) {
            this.cascaderShow = false;
            this.cascaderLabel = selectedOptions.map((option) => option.cate_name).join('/');
            this.orderInfo.cate_ids = selectedOptions.map((option) => option.cate_id);
        },
        getBindOrder() {
            this.api.getBindOrder({ work_id: parseInt(this.$route.params.id) }).then(data => {
                this.bindOrderList = data.data.result || [];
                if (this.bindOrderList.length != 0) {
                    this.showbindOrder = true;
                } else {
                    this.showbindOrder = false;
                }
            });
        },
        cancelBind(id) {
            this.$refs.tip.show = true;
            this.bindOrderId = id;
        },
        cancelConfirm() {
            this.api.cancelBindOrder({ work_id: parseInt(this.$route.params.id), other_id: parseInt(this.bindOrderId) }).then(data => {
                this.$message.success('操作成功！');
                this.getBindOrder();
                this.getWorkLog();
                this.$refs.tip.show = false;
            });

        },
        save(type) {
            if (type == 'reply') {
                if (!this.replyData.action_desc && !this.reply) return;
                this.replyData.action = 'reply_action';
                this.replyData.work_id = this.orderInfo.work_id;
                this.api.updateWorkInfo(this.replyData).then(data => {
                    this.getWorkLog();
                    this.$message.success('回复成功!');
                    this.$refs.reply.$refs.upload.clearFiles();
                    this.$refs.reply.fileSize = 0;
                    this.$refs.reply.fileList = [];
                    this.replyData.file_list = [];
                    this.replyData.action_desc = '';
                })
            }
            else if (type == 'orderInfo') {
                this.$refs[type].resetFields();
                this.editTitle = false;
            }
            else if (type == 'editTitle') {
                if (this.orderInfo.work_title == '' || this.orderInfo.work_desc == '') {
                    this.$message.warning('工单标题和描述不能为空!');
                    return;
                }
                this.orderInfo.action = 'modify_action';
                this.orderInfo.sell_time = this.orderInfo.sell_time ? this.orderInfo.sell_time : 0;
                this.api.updateWorkInfo(this.orderInfo).then(data => {
                    this.getWorkLog();
                    this.$router.replace('?title=' + this.orderInfo.work_title);
                    this.$message.success('修改成功!');
                })
                this.editTitle = false;
            }
            else {
                if (this.saveState) {
                    this.orderInfo.action = 'modify_action';
                    this.orderInfo.product_id = this.orderInfo.product_id ? this.orderInfo.product_id : 0;
                    this.orderInfo.sell_time = this.orderInfo.sell_time ? this.orderInfo.sell_time : 0;
                    this.orderInfo.client_name = this.orderInfo.client_name.trim();
                    this.orderInfo.client_phone = this.orderInfo.client_phone.trim();
                    this.orderInfo.client_email = this.orderInfo.client_email.trim();
                    this.orderInfo.client_addr = this.orderInfo.client_addr.trim();
                    if (this.showExchanged == true) {
                        this.orderInfo.exchanged_List.push(this.exchangedInfo);
                        this.exchangedInfo = {
                            exchanged: '',
                            exchanged_desc: '',
                            exchanged_return_num: '',
                            exchanged_return_kd: '',
                            exchanged_send_num: '',
                            exchanged_send_kd: '',
                            exchanged_return_time: '',
                            exchanged_send_time: '',
                        };
                        this.showExchanged = false;
                    }

                    var arr = this.orderInfo.exchanged_List || [];
                    if (arr.length > 0 && (arr[arr.length - 1].exchanged == '' || arr[arr.length - 1].exchanged == '无需')) {
                        this.showReturnBtn = false;
                    } else {
                        this.showReturnBtn = true;
                    }
                    // console.log(this.showReturnBtn)
                    this.api.updateWorkInfo(this.orderInfo).then(data => {
                        this.saveState = false
                        this.getWorkLog();
                        this.getOrderInfo();
                        this.$message.success('修改成功!');
                    })
                }

            }

        },
        getUser() {
            this.api.getUser({ order_rule: 'work-order' }).then(data => {
                this.user = data.data.userList;
            })
        },
        delOrder() {
            this.$refs.delTip.show = true;
        },
        tipBack() {
            this.api.deleteWork({ work_id: this.searchData.work_id }).then(data => {
                this.$message.success('删除成功!');
                this.$refs.delTip.show = false;
                this.$router.push({ name: 'order-manage', params: { reload: 'true' }, query: { state: 'work_running' } });
            });
        },
        tryReminder(type, title) {//催单,先确认是否可以催单
            this.api.tryReminder({ work_id: this.searchData.work_id }).then(data => {
                this.openDialog(type, title)
            })
        },
        openDialog(type, title) {
            this.actData = {

            };
            if (type == 'end') {
                if (!this.orderInfo.problem_source || this.orderInfo.cate_ids.length == 0) {
                    this.$message.warning('问题责任方或问题分类未填写!');
                    return;
                }
                this.actData = {
                    exchanged: this.orderInfo.exchanged || '无需',
                    file_list: [],
                    action: 'end_action'
                }
            } else if (type == 'bind') {
                if (this.bindOrderList.length >= 10) {
                    this.$message.warning(this.orderInfo.work_num + '已关联10条工单');
                    return
                }
            } else if (type == 'reminders') {  //催单
                this.actData = {
                    action: 'reminder_action'
                }
            } else if (type == 'reply') {  //回复
                this.actData = {
                    action: 'reply_action'
                }

            } else if (type == 'restart') {
                this.actData = {
                    action: 'restart_action'
                }
            } else {
                this.actData.handerIdOld = this.orderInfo.handler_id;
                this.actData.handerOld = this.orderInfo.handler_name;
                this.actData.action = 'forward_action';
            }
            this.actData.work_id = this.orderInfo.work_id;
            this.dislog = {
                type: type,
                title: title,
                show: true,
            };
            this.$refs.dislog.show = true;
        },
        openBindDialog() {
            this.actData = {};
            if (this.bindOrderList.length >= 10) {
                this.$message.warning(this.orderInfo.work_num + '已关联10条工单');
                return
            }
            this.actData.work_id = this.orderInfo.work_id;
            this.$refs.bind_dislog.show = true;
        },
        bindDialogAct() {
            if (this.bindData.val == '') {
                this.$message.warning('请输入工单号或外部工单号');
                return;
            }
            if (this.bindData.type == 0) {
                this.actData.work_num = this.bindData.val;
                this.actData.work_idout = '';
            } else if (this.bindData.type == 1) {
                this.actData.work_idout = this.bindData.val;
                this.actData.work_num = '';
            }
            this.api.bindOrder(this.actData).then(data => {
                this.$message.success('操作成功！');
                this.getBindOrder();
                this.getWorkLog();
                this.$refs.bind_dislog.show = false;
            })
        },
        dislogAct() {
            this.$refs.formRule.validate(v => {
                if (v) {
                    if (this.dislog.type == 'reply') {
                        if (!this.replyData.action_desc && !this.reply) return;
                        this.replyData.action = 'reply_action';
                        this.replyData.work_id = this.orderInfo.work_id;
                        this.api.updateWorkInfo(this.replyData).then(data => {
                            this.getWorkLog();
                            this.$message.success('回复成功!');
                            this.$refs.reply.$refs.upload.clearFiles();
                            this.$refs.reply.fileSize = 0;
                            this.$refs.reply.fileList = [];
                            this.replyData.file_list = [];
                            this.replyData.action_desc = '';
                            this.$refs.dislog.show = false;
                            this.dislog.show = false;
                        })
                        return;
                    }
                    if (this.dislog.type == 'bind') {
                        if (this.bindData.val == '') {
                            this.$message.warning('请输入工单号或外部工单号');
                            return;
                        }
                        if (this.bindData.type == 0) {
                            this.actData.work_num = this.bindData.val;
                            this.actData.work_idout = '';
                        } else if (this.bindData.type == 1) {
                            this.actData.work_idout = this.bindData.val;
                            this.actData.work_num = '';
                        }
                        this.api.bindOrder(this.actData).then(data => {
                            this.$message.success('操作成功！');
                            this.getBindOrder();
                            this.getWorkLog();
                            this.$refs.dislog.show = false;
                            this.dislog.show = false;
                        })
                        return
                    }
                    if ((this.dislog.type == 'reminders' || this.dislog.type == 'restart') && !this.actData.action_desc) {
                        this.$message.warning('请输入备注信息!');
                        return;
                    }
                    if ((this.dislog.type == 'end' && !this.actData.action_desc)) {
                        this.$message.warning('请输入解决方案!');
                        return;
                    }
                    this.api.updateWorkInfo(this.actData).then(data => {
                        this.$message.success('操作成功！');
                        this.getOrderInfo();
                        this.getWorkLog();
                        this.$refs.dislog.show = false;
                        this.dislog.show = false;
                        if (this.dislog.type == 'end') this.$refs.end_upload.clearFiles(); return;

                    })
                }
            });

        },
        fileChange(file, type, i) {
            if (this.dislog.type == 'end') {
                if (type == 'upload') {
                    this.actData.file_list.push(file);
                } else {
                    this.actData.file_list.splice(i, 1);
                }
            } else {
                if (type == 'upload') {
                    this.replyData.file_list.push(file);
                } else {
                    this.replyData.file_list.splice(i, 1);
                }
            }
        },
        getWorkLog() {
            this.api.getWorkLog({ work_id: this.searchData.work_id }).then(data => {
                this.workLog = data.data.logList;
                this.logActive = [];
                this.workLog.forEach(item => {
                    if (item.action_desc || item.file_url) {
                        this.logActive.push(item.id);
                    }
                });
            })
        },
        descForm(data) {
            return eval('(' + data + ')');
        },
        goKdPage(val) {
            window.open('https://t.17track.net/en#nums=' + val, "_blank");
        },
        goDetail(row, column, event) {
            if (window.h5sdk) {
                this.searchData.work_id = parseInt(row.work_id);
                this.$router.push({ name: 'order-detail', params: { id: row.work_id }, query: { title: row.work_title } });
                return;
            }
            const detail = this.$router.resolve({
                name: `order-detail`,
                params: {
                    id: row.work_id
                },
                query: {
                    title: row.work_title
                }
            });
            window.open(detail.href, "_blank");
        },
        goUserManage(account) {
            this.api.getUserByAccount({ account: account }).then(data => {
                if (data.data.result.data.list[0]) {
                    var ali_user_id = data.data.result.data.list[0].ali_user_id;
                    var region = data.data.result.region;
                    if (window.h5sdk) {
                        this.$router.push({ name: 'user-detail', params: { id: ali_user_id }, query: { region: region } });
                        return;
                    }
                    const page = this.$router.resolve({
                        name: 'user-detail',
                        params: { id: ali_user_id }, query: { region: region }
                    });
                    window.open(page.href, "_blank");
                }
            })
        },
        goDevice(sn) {
            this.api.getIotDeviceDetail({ deviceName: sn }).then(data => {
                if (data.data.result) {
                    var res = data.data.result[0];
                    var iotId = res.iotId;
                    var region = res.region;
                    if (window.h5sdk) {
                        this.$router.push({ name: 'device-detail', params: { id: iotId }, query: { region: region, deviceName: res.deviceName } });
                        return;
                    }
                    const page = this.$router.resolve({
                        name: 'device-detail',
                        params: { id: iotId }, query: { region: region, deviceName: res.deviceName }
                    });
                    window.open(page.href, "_blank");
                } else if (data.code == 50001) {
                    this.$message.error(data.msg);
                }
            })
        },
        goFeedback(id,title,region){
            if (window.h5sdk) {
                this.$router.push({ name: 'feedback-detail', params: { id: id }, query: { title: title, region: region } });
                return;
            }
            const detail = this.$router.resolve({
                name: 'feedback-detail',
                params: {
                    id: id

                },
                query: { title: title, region: region }
            });
            window.open(detail.href, "_blank");
        }
    }
})
</script>
<style lang="less" scoped>
.order-detail {
    overflow: hidden;
    background-color: #f3f3f3;
    padding: 0;
}

.detail_box {
    height: 100%;
    .flexLayout(flex-start, flex-start, nowrap);

    >div {
        height: 100%;
        background-color: #fff;
        border-radius: 6px;
        overflow: hidden;
    }

    .order_content {
        width: 460px;
        margin-left: 20px;
        position: relative;

        .order_main {
            height: 100%;
            overflow: auto;
            padding: 20px 30px 70px;
            box-sizing: border-box;
        }

        /deep/ .el-tabs {
            .el-tabs__nav-wrap {
                &::after {
                    width: 0;
                }

                .el-tabs__item {
                    color: #868998;
                    font-size: 16px;
                    font-weight: 600;

                    &.is-active {
                        color: #333;
                    }
                }

                .el-tabs__active-bar {
                    background-color: @colorBlue2;
                }
            }

            .el-select,
            .el-cascader {
                width: 100%;
            }

            .el-form-item {
                margin-bottom: 8px;
            }
        }

        .act_box {
            width: 100%;
            padding: 14px 0 14px 38px;
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            background: #fff;
        }

        .el-form-item {
            margin-bottom: 13px;
        }

        .receive_title {
            padding: 15px 0 20px 0;
            font-weight: bold;
        }

        .returns_title {
            padding: 20px 0 5px 0;
            font-weight: bold;
        }

        .returns_list {
            border-bottom: 1px dashed #bbb;

            .padd {
                margin-bottom: 0px;
            }
        }

        .kd_box {
            position: relative;
        }

        .kd {
            position: absolute;
            right: 10px;
            top: 0;
            padding-top: 10px;
        }

        .x_align {
            margin-left: 95%;
            padding: 0;
        }

        /deep/ .el-button span {
            background: #fff;
        }
    }



    .log_box {
        flex: 1;

        padding: 0 0 80px;
        box-sizing: border-box;
        font-size: 14px;
        position: relative;

        .log_box_inner{
            padding-top: 20px;
            overflow: auto;
            height: 100%;
        }

        .title_box {
            margin-bottom: 10px;
            .flexLayout(space-between, center);

            .order_state {
                margin-left: 14px;
            }
        }

        .reply_box {
            padding: 0 30px 20px;
            margin-bottom: 20px;
            border-bottom: 1px solid @colorLine;

            .mb {
                margin-bottom: 13px;
            }

            .work_title {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .btn_align {
                text-align: end;

                .btn_color {
                    color: #909399;
                }
            }

            .white {
                width: 90px;
                color: @colorBlue2;
                border-color: @colorBlue;
            }

            .order_text {
                line-height: 1.7;

                &>div {
                    margin-bottom: 6px;
                }

                .order_title {
                    color: #333;
                    font-size: 0.16rem;

                }

                .order_desc {
                    color: #666;
                }
            }

            .act_box {
                .flexLayout(flex-end);

                .button {
                    margin: 0;
                    margin-left: 10px;

                    &.del {
                        color: #EB534B;
                        border-color: #EB534B;
                    }

                    &.reminders {
                        color: #F8AF0C;
                        border-color: #F8AF0C;
                    }

                    &.end {
                        color: #00D6B9;
                        border-color: #00D6B9;
                    }
                }
            }

            @media(max-width: 1390px) {
                display: block;

                .act_box {
                    margin-top: 20px;
                }
            }
        }

        .log {
            padding: 0 30px 20px;

            /deep/ .el-collapse {
                border: none;

                .el-collapse-item {
                    padding-bottom: 20px;
                    margin-bottom: 20px;
                    border-bottom: 1px solid #EBEEF5;

                    &:last-child {
                        border-bottom: none;
                    }

                    .el-collapse-item__header {
                        border: none;
                        background: #F7F8FA;
                        text-indent: 20px;
                        height: 40px;
                        line-height: 40px;

                        .collapse_title {
                            width: 100%;
                            .flexLayout(space-between, center);

                            .title_left {
                                .handle_name {
                                    font-weight: 600;
                                }
                            }

                            .collapse_time {
                                margin-right: 20px;
                            }
                        }

                        .el-collapse-item__arrow {
                            text-indent: 0;
                            font-weight: 600;
                            transform: rotate(90deg);
                            font-size: 16px;
                            color: @colorBlue;

                            &.is-active {
                                transform: rotate(-90deg);
                            }
                        }
                    }

                    .el-collapse-item__wrap {
                        padding: 16px 20px 0;
                        border-bottom: none;

                        .el-collapse-item__content {
                            padding: 0;

                            .modify_info {
                                span {
                                    &:first-child {
                                        color: #999;
                                        padding-right: 10px;
                                    }
                                }
                            }
                        }
                    }
                }

            }

            /deep/ .el-form {
                width: 100%;

                .el-form-item {
                    margin: 0 0 5px 0;

                    .el-form-item__label,
                    .el-form-item__content {
                        line-height: 1.7;
                    }
                }
            }

        }

        .priority1 {
            color: #F8AF0C;
        }

        .priority2 {
            color: #00D6B9;
        }

        .priority3 {
            color: #EB534B;
        }

        .act_list {
            position: absolute;
            padding: 14px 30px;
            // border-top: solid 1px #E8E9F1;
            width: calc(100% - 60px);
            bottom: 0;
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 20%);
            .flexLayout(space-between, center);

            .bind_text {
                color: #507FF7;
            }

            .act_box {
                .flexLayout(flex-end);

                .button {
                    margin: 0;
                    margin-left: 10px;

                    &.del {
                        color: #EB534B;
                        border-color: #EB534B;
                    }

                    &.reminders {
                        color: #F8AF0C;
                        border-color: #F8AF0C;
                    }

                    &.transfer {
                        color: #507FF7;
                        border-color: #507FF7;
                    }

                    &.end {
                        color: #00D6B9;
                        border-color: #00D6B9;
                    }
                }
            }
            .default_btn{
                border: 1px solid #E8E9F1;
            }
        }
    }
}

.bind {
    // padding: 0 30px;
    // border-bottom: 1px solid #E8E9F1;
    // margin-bottom: 30px;

    .bind_text {
        color: #507FF7;
    }

    .bind_btn {
        text-align: right;
    }

    .btn_bg {
        background-color: #E1EAFF;
        border: 0;
    }

    .running {
        color: @colorBlue2;
        padding: 5px 9px;
        background-color: #E1EAFF;
    }

    .end {
        color: #00D6B9;
        padding: 5px 9px;
        background-color: #E4F9F8;
    }

    /deep/ td {
        cursor: pointer;
    }

    /deep/ .el-collapse {
        border: none;

        .el-collapse-item {
            // padding-bottom: 20px;
            // margin-bottom: 20px;
            border-bottom: 1px solid #EBEEF5;

            .el-collapse-item__header {
                border: none;
                background: #F7F8FA;
                text-indent: 20px;

                .collapse_title {
                    width: 100%;
                    .flexLayout(space-between, center);

                    .title_left {
                        .handle_name {
                            font-weight: 600;
                        }
                    }

                    .collapse_time {
                        margin-right: 20px;
                    }
                }

                .el-collapse-item__arrow {
                    text-indent: 0;
                    font-weight: 600;
                    transform: rotate(90deg);
                    font-size: 16px;
                    color: @colorBlue;

                    &.is-active {
                        transform: rotate(-90deg);
                    }
                }
            }

            .el-collapse-item__content {
                padding-bottom: 0;
            }

            .el-collapse-item__wrap {
                border-bottom: 0;
            }

        }

    }

    .bind_title {
        font-weight: 600;
    }
}

.upload_file {
    margin-top: 25px;
    .flexLayout(space-between, flex-start);
    flex-wrap: nowrap;

    .upload_left {
        color: #999;

        /deep/ .el-upload {
            .upload_btn {
                color: #5192FF;
                .flexLayout(f, center);

                img {
                    width: 24px;
                }
            }
        }
    }

    .upload_right {
        .button {
            margin-right: 0;
        }
    }
}



.el-textarea {
    /deep/ .el-textarea__inner {
        padding-bottom: 36px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/order/order-manage/order-detail.vue